export enum PROMOTION_TYPE {
  RATE = 0,
  AMOUNT = 1,
}

export enum TARGET_PROMOTION_TYPE {
  PRODUCT = 0,
  ORDER = 1,
}

export enum METHOD_DISCOUNT_ORDER_TYPE {
  DISCOUNT_BY_ORDER = 3,
  DISCOUNT_BY_GIFT = 4,
  DISCOUNT_BY_PRODUCT = 5,
}

export enum METHOD_DISCOUNT_PRODUCT_TYPE {
  DISCOUNT_BY_QUANTITY = 0,
  DISCOUNT_BY_GIFT = 1,
  DISCOUNT_BY_PRICE = 2,
}

export const CONDITION_GROUP_TYPE = {
  PRODUCT: 'PRODUCT',
  CATEGORY: 'CATEGORY',
  SUB_CATEGORY: 'SUB_CATEGORY',
};

export const CONDITION_DISCOUNT_TYPE = {
  DISCOUNT: 'DISCOUNT',
  PRICE: 'PRICE',
};

export const DISCOUNT_TARGET = {
  PRODUCT: 'PRODUCT',
  CATEGORY: 'CATEGORY',
};

export const optionsPromotionValue = [
  { label: '%', value: PROMOTION_TYPE.RATE },
  { label: 'VNĐ', value: PROMOTION_TYPE.AMOUNT },
];

export const targetDiscountOptions = [
  { label: 'Sản phẩm', value: TARGET_PROMOTION_TYPE.PRODUCT },
  { label: 'Đơn hàng/hóa đơn', value: TARGET_PROMOTION_TYPE.ORDER },
];

export const methodDiscountOptions = {
  [TARGET_PROMOTION_TYPE.PRODUCT]: [
    {
      label: 'Giá bán theo số lượng',
      value: METHOD_DISCOUNT_PRODUCT_TYPE.DISCOUNT_BY_QUANTITY,
    },
  ],
  [TARGET_PROMOTION_TYPE.ORDER]: [
    {
      label: 'Giảm giá đơn hàng',
      value: METHOD_DISCOUNT_ORDER_TYPE.DISCOUNT_BY_ORDER,
    },
    {
      label: 'Giảm giá sản phẩm',
      value: METHOD_DISCOUNT_ORDER_TYPE.DISCOUNT_BY_PRODUCT,
    },
  ],
};
